export const getCookie = (cookie: string) => {
	const cookieSplit = cookie.split(';');

	const arrCookies = cookieSplit.map((coo) => {

		const cookieSinEspacios = coo.trim();
		const separarValue = cookieSinEspacios.split('=');
		const value = separarValue.pop();
		const name = separarValue.pop();

		return { name, value };
	});

	const arrfiltrado = arrCookies.find(({ name }) => name === 'token');

	if (arrfiltrado === undefined) {
		const arrFiltradoInvitado =  arrCookies.find(({ name }) => name === 'tt-jwt-gauth');
		return arrFiltradoInvitado;
	}

	return arrfiltrado;
};